import services from './api';
import {
  clearClientSession,
  clearProviderSession,
  saveClientSession,
  saveProviderSession,
} from './session';

// A sessao e o cookie HttpOnly: so a API sabe se ele vale. GET /session responde 200 sempre,
// com { user, company } e null para o lado sem sessao.
const SESSION_CACHE_MS = 30 * 1000;
const EMPTY_SESSION = { user: null, company: null };

let cached = null;

export function clearSessionCache() {
  cached = null;
}

export function getSession({ force = false, now = Date.now() } = {}) {
  if (!force && cached && now - cached.at < SESSION_CACHE_MS) {
    return cached.promise;
  }
  const promise = services.apiV1
    .get('session')
    .then(({ data }) => ({
      user: (data && data.user) || null,
      company: (data && data.company) || null,
    }))
    .catch((error) => {
      // Falha de rede nao derruba a sessao; so deixa de cachear o resultado.
      if (cached && cached.promise === promise) clearSessionCache();
      if (error && error.response && error.response.status === 401) {
        return EMPTY_SESSION;
      }
      throw error;
    });
  cached = { at: now, promise };
  return promise;
}

export async function getSessionUser(options) {
  return (await getSession(options)).user;
}

export async function getSessionCompany(options) {
  return (await getSession(options)).company;
}

// Apaga o cookie na API e depois limpa o storage; o storage e limpo mesmo se a chamada falhar.
export async function logout(area = 'client') {
  try {
    await services.apiV1.post('session/logout');
  } catch (error) {
    // sem rede ou sessao ja expirada: o cookie some sozinho no Max-Age
  } finally {
    clearSessionCache();
    if (area === 'provider') clearProviderSession();
    else clearClientSession();
  }
}

// Chamadas de login/cadastro: gravam os dados de exibicao e descartam o cache de GET /session,
// que pode guardar "sem sessao" de antes do login.
export function openClientSession(data) {
  clearSessionCache();
  saveClientSession(data);
}

export function openProviderSession(data) {
  clearSessionCache();
  saveProviderSession(data);
}
